module.exports = __webpack_public_path__ + "static/media/urcLogo.835b3a86.png";